const SETTING_TYPES = {
  // Table Columns
  SLATypesTableColumnKey: "cplSLATypesTableColumnOrder",
  DocumentSubTypesTableColumnKey: "cplDocumentSubTypesTableColumnOrder",
  UserTasksTableColumnKey: "cplUserTasksTableColumnOrder",
  CaseTypesTableColumnKey: "cplCaseTypesTableColumnOrder",
  CaseStatusTypesTableColumnKey: "cplCaseStatusTypesTableColumnOrder",
  MeetingTypesTableColumnKey: "cplMeetingTypesTableColumnOrder",
  CaseTableColumnKey: "cplCaseTableColumnOrder",
  MeetingsTableColumnKey: "cplMeetingsTableColumnOrder",
  UserTableColumnKey: "cplUserTableColumnOrder",
  UserTableVisibleColumns: "cplUserTableVisibleColumns",
};

export { SETTING_TYPES };
